import { User } from '@/Domain/api/User/dto/User.dto';

export class UserHelper {
  static getFullName(user: User | null | undefined): string | null {
    if (!user) return null;

    if (user.first_name || user.last_name) {
      return `${user.first_name} ${user.last_name}`;
    }

    return null;
  }
}
